import {reduxForm, Field, formValueSelector} from 'redux-form'
import LabelSection from 'components/sections/LabelSection'
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper'
import styles from './ModifierForm.css'
import {askDeleteModifier, onClickCancel} from 'actions/library/modifier'
import {connect} from 'react-redux'
import ModifierOptions from './ModifierOptions'
import ModifierOptionsModal from './ModifierOptionsModal'
import settingField from 'components/Fields/ReduxForm/SettingField/SettingField'

/**
 * This validation is commented out because PM wants to use the back-end validation
 * Reason : match moka-rails
 * https://mokapos.atlassian.net/browse/PS-527
 */
const validate = (values) => {
  const errors = {}
  if ((!values.name) || (values.name.trim() === '')) {
    errors.name = 'This field is required'
  } else if (values.name.length > 100) {
    errors.name = 'Name max 100 char'
  }
  // let optionsError = []
  // if (values.options) {
  //   values.options.forEach((member, index) => {
  //     const memberErrors = {}
  //     if ((!member.name) || (member.name.trim() === '')) {
  //       memberErrors.name = 'Please enter a value'
  //     }
  //     if (parseInt(member.price) > 99999999999) {
  //       memberErrors.price = 'Price must be less than or equal to 99999999999'
  //     }
  //     optionsError[index] = memberErrors
  //   })
  // }
  // errors.options = optionsError
  return errors
}

class ModifierForm extends React.Component {
  render () {
    const {handleSubmit, modifier, outlets, isSubmittingForm} = this.props

    return (<form className={styles.wrapper}>
      <div className={`${styles['content-wrapper']} modifier-content-wrapper`}>
        <div className='row mb-20px'>
          <div className='col-sm-12'>
            <Field component='input' type='hidden' name='id' />
            <LabelSection title='modifier set' />
            <div className='form-group'>
              <Field
                component={settingField}
                name='name'
                type='text'
                placeholder='Name'
                className='form-control'
              />
            </div>
          </div>
        </div>
        <LabelSection title='modifier options' />
        <ModifierOptions />
      </div>
      <ActionBarDetailWrapper>
        <span className='pull-left'>
          {modifier.id && <button className='btn btn-danger' onClick={this._onClickDelete} disabled={isSubmittingForm}><i className='fa fa-trash' /> </button>}
        </span>
        <span className='pull-right'>
          <button className='btn btn-default mr-10px' onClick={this._onCancel} disabled={isSubmittingForm}>Cancel</button>
          {outlets.length > 1 && !modifier.id && <button className='btn btn-primary mr-10px' onClick={handleSubmit(this._onSubmitCreateAllOutlet)} disabled={isSubmittingForm}>Save to All Outlet</button>}
          <button className='btn btn-primary' onClick={handleSubmit(this._onSubmitSave)} disabled={isSubmittingForm}>Save</button>
        </span>
      </ActionBarDetailWrapper>
      <ModifierOptionsModal />
    </form>)
  }

  _onSubmitCreateAllOutlet = (values) => {
    this.props.onSubmit({...values, action: 'save_to_all_outlet'})
  }

  _onSubmitSave = (values) => {
    this.props.onSubmit({...values, action: 'save'})
  }

  _onClickDelete = (event) => {
    const {dispatch, modifierDetail} = this.props
    dispatch(askDeleteModifier(modifierDetail))
    // prevent form from submitting
    event.preventDefault()
    event.stopPropagation()
  }

  _onCancel = (e) => {
    const {dispatch} = this.props
    dispatch(onClickCancel())
    e.preventDefault()
    e.stopPropagation()
  }
}
const mapForm = {
  form: 'modifier',
  touchOnBlur: false,
  touchOnChange: false,
  validate,
  // TODO refactor
  // ni karena ada dua field yang sama ('options') di form dan modal,
  // kalo modalnya diclose, sama react bakal jadi 'unmounted'
  // dan kalo diunmount, redux form bakal destroy state reduxnya
  // akibatnya field yang ada di list options form bakal hilang validasinya
  // harusnya: dibikin dua field aja
  destroyOnUnmount: false
}

const selector = formValueSelector('modifier')

function mapStateToProps (state) {
  const {modifierDetail, outlets, isSubmittingForm} = state.library.modifier
  return {
    modifier: {
      id: selector(state, 'id')
    },
    modifierDetail,
    outlets,
    isSubmittingForm
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ModifierForm))



// WEBPACK FOOTER //
// ./app/pages/Library/Modifier/Detail/ModifierForm/ModifierForm.js